import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslationItemEditModel } from '../model';

const basePath = '/api/translation-items';

@Injectable({
    providedIn: 'root',
})
export class TranslationItemClient {
    private readonly http = inject(HttpClient);

    save(data: TranslationItemEditModel) {
        return this.http.post(`${basePath}`, data);
    }
}
